import React, { useEffect, useState, useRef, useCallback } from "react";
import { useSpring } from "react-spring";
import "../../Components/componentsStyle.css";
import "../MainChatPage.js/mainChatPageStyle.css"
import tataPlayLogo from "../../Images/tata-sky-logo.jpg";

import { Player, Controls } from "@lottiefiles/react-lottie-player";
import Icon from "@ant-design/icons/lib/components/Icon";

import { RobotOutlined } from "@ant-design/icons";

import FeedbackPopUp from "../../Components/FeedbackPopUp/FeedbackPopUp";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import Conversation from "../Conversation/conversation";
import RelatedArticles from "../Conversation/RelatedArticles";
import apiService from "../../Services/apiServices";
import ChatPopup from "../../Components/ChatPopUp/ChatPopup";
// import DowntimeScreen from "../../Components/DowntimeScreen/DowntimeScreen";
import TabBar from "../../Components/TabBar/TabBar";
import WorkflowChat from "../../Components/WorkflowChat/WorkflowChat";
import A1MenuButtons from "../../Components/MessageCodes/A1MenuButton/A1MenuButtons";
import { handledButtonsUI } from "../../Components/Methods/Methods";

export default function MainChatPage(props) {
  const fadeIn = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    config: { duration: 1000 }, // You can adjust the duration as needed
  });
  const {
    messages,
    addMessages,
    minimized,
    clearMessages,
    loading,
    updateMessage,
    setIsShowMaximumChat,
    showMaximumChat,
    setShowMinimizedChat,
    showMinimizedChat,
    userDetails,
    setToken,
    isShowBot,
    setIsShowBot,
    setCode,
    token,
    sessionId,
    reLogin,
    setRelogin,
    setisSubscriber,
    isSubscriber,
    showMsgs,
    setShowMsgs,
    setDisableInputBox,
    disableInputBox,
    addMessagesPhase2,
    verifyAgent,
    agentGroup,
    agentType,
    agentName,
    agentLogID,
    uniqueId,
    checkOfflineButton,   
    launchOnButton, 
    flow, 
  } = props;
  const probing = false;

  const [inputValue, setInputValue] = useState("");
  const [customerInputs, setCustomerInputs] = useState("");
  const [showBotFlow, isSetBotFlow] = useState(false);

  const [isFeedbackPop, setIsFeedbackPop] = useState(false);
  const [IsThirtyMinPopUP ,setIsThirtyMinPopUP] = useState(false)

  const [finalTimerFlag, setFinalTimerFlag] = useState(false);
  
  const [checkThumsDownFeedback ,setCheckThumsDownFeedback] = useState([])
  const [IndexForPopUp , setIndexForPopUp]= useState(Number)

  const [saveFeedbackData , setSaveFeedbackData] = useState('')
  const [showR1FeedbackPop, setShowR1FeedbackPop] = useState({ isActive: false, option: "" })
  const [showUrlPopUp, setShowUrlPopUp] = useState({ isActive: false, url: "" })
  const messagesEndRef = useRef(null);
  const hasEffectRun = useRef(false);

  // Tab system state
  const [activeTab, setActiveTab] = useState("main");
  const [tabs, setTabs] = useState([{ id: "main", label: "Chat", closable: false }]);
  const [tabSessions, setTabSessions] = useState({});
  const openingTabsRef = useRef(new Set());
  const [quickActionData, setQuickActionData] = useState(null);
  const [quickActionViewMenu, setQuickActionViewMenu] = useState(null);
  const workflowChatRef = useRef(null);
  const prevSessionIdRef = useRef(null);

  // Close all workflow tabs when session id changes (new session)
  useEffect(() => {
    if (!sessionId || isNaN(sessionId)) return;
    if (prevSessionIdRef.current !== null && prevSessionIdRef.current !== sessionId) {
      setTimeout(() => {
        setTabs([{ id: "main", label: "Chat", closable: false }]);
        setTabSessions({});
        setActiveTab("main");
        openingTabsRef.current.clear();
      }, 3000);
    }
    prevSessionIdRef.current = sessionId;
  }, [sessionId]);

  const onQuickActionsChange = useCallback((data, viewMenuInfo) => {
    setQuickActionData(data);
    setQuickActionViewMenu(viewMenuInfo);
  }, []);


  let idleTimer;
  let secondIdleTimer;
  let finalTimer;

  const [idleTime, setIdleTime] = useState(0);

  useEffect(() => {
    let isFinalTimerTriggered = false;

    const handleUserActivity = () => {
      clearTimeout(idleTimer);
      clearTimeout(secondIdleTimer);

      // if (!chatEnd) {
      //   setIdleTime(0);
      // }

      if ( !isFinalTimerTriggered) {
        clearTimeout(finalTimer);

        // idleTimer = setTimeout(() => {
        //   setIdleTime(idleTime + 1);
        //   let initialArray = [];
        //   initialArray.push({
        //     uiCommand: "idle",
        //     text: "Hey there! We're eagerly waiting for you & we'd love to help you with your query.",
        //   });
        // }, 5 * 60 * 1000);

        // secondIdleTimer = setTimeout(() => {
        //   setIdleTime(idleTime + 1);
        //   let initialArray = [];
        //   initialArray.push({
        //     uiCommand: "idle",
        //     text: "Hey there! We're eagerly waiting for you & we'd love to help you with your query.",
        //   });
        // }, 10 * 60 * 1000);

        finalTimer = setTimeout(() => {
          // setIdleTime(idleTime + 1);
          // setDisableBtns((val) => !val);
          setFinalTimerFlag(true)
          // props.setIsSessionExpired(true);
          // isFinalTimerTriggered = true;
          setIsThirtyMinPopUP(true)
          setShowMsgs(false)
          setDisableInputBox(true)
          // props.setShowIdlePopup(true);
        }, 90 * 60 * 1000 );
      }
    };

    const resetIdleTimer = () => {
      handleUserActivity();
    };

    if (!finalTimerFlag  && !props.isChatWithUs) {
      console.log("INSIDE add event listner", finalTimerFlag);
      // window.addEventListener("mousemove", resetIdleTimer);
      // window.addEventListener("keydown", resetIdleTimer);
      window.addEventListener("click", resetIdleTimer);
    }

    console.log("First render");
    console.log("IS FINAL timer triggerded? ", isFinalTimerTriggered);

    // if (chatEnd) {
    //   console.log("Re-render");
    //   clearTimeout(idleTimer);
    //   clearTimeout(secondIdleTimer);
    //   clearTimeout(finalTimer);
    //   // window.removeEventListener("mousemove", resetIdleTimer);
    //   // window.removeEventListener("keydown", resetIdleTimer);
    //   window.addEventListener("click", resetIdleTimer);
    // }
    return () => {
      clearTimeout(idleTimer);
      clearTimeout(secondIdleTimer);
      clearTimeout(finalTimer);
      // window.removeEventListener("mousemove", resetIdleTimer);
      // window.removeEventListener("keydown", resetIdleTimer);
      window.addEventListener("click", resetIdleTimer);
    };
  }, []);

  useEffect(() => {
    if (finalTimerFlag) {
      let n = document.getElementsByClassName("action-tab");

      for (let i = 0; i < n.length; i++) {
        n[i].disabled = true;
        n[i].style.cursor = "not-allowed";
      }
    }
  }, [finalTimerFlag]);

  const scrollToBottom = () => {
    const scrollContainer = messagesEndRef.current;
    if (!scrollContainer) return; 
  
    // Calculate 60% scroll amount
    const scrollAmount = scrollContainer.scrollTop + scrollContainer.clientHeight * 0.6;
  
    // Scroll smoothly to the calculated position
    scrollContainer.scrollTo({
      top: scrollAmount,
      behavior: "smooth",
    });
  };
  
  // ✅ Run scroll AFTER chat message transition completes
  useEffect(() => {
    setTimeout(scrollToBottom, 350); 
  }, [messages]);
  
  

  useEffect(()=>{
    if(reLogin){
      startLogin()
      setRelogin(false)
    }
    
  },[reLogin])

  const handleKeyPress = (event) => {
    if (event.key === "Enter" && inputValue.length > 0 && inputValue.trim() !== "") {
      setShowMsgs(true);
      if (activeTab === "main") {
        addMessages(inputValue);
      } else if (workflowChatRef.current) {
        workflowChatRef.current.addMessages(inputValue);
      }
      sessionStorage.setItem("inputValueBot", inputValue);
      setInputValue("");
    }
  };

  const onSendMsg = () => {
    if (inputValue.length > 0) {
      isSetBotFlow(true);
    }
  };

  const handleClose = () => {
    setIsShowBot(false);
    setIsShowMaximumChat(false);
  };

  const handleSend = () => {
    if (inputValue.length > 0 && inputValue.trim() !== "") {
      if (activeTab === "main") {
        addMessages(inputValue);
      } else if (workflowChatRef.current) {
        workflowChatRef.current.addMessages(inputValue);
      }
      setShowMsgs(true);
      sessionStorage.setItem("inputValueBot", inputValue);
    }
    setInputValue("");
  };

  const handleInput = (e) => {
    setInputValue(e.target.value);
    sessionStorage.setItem("inputValueBot", e.target.value);
    setCustomerInputs(e.target.value);
  };

  const chatReopenFunction = (token) => {
    sessionStorage.setItem("token", token);
    // setLoginLoader(true);
    addMessages(null , null)
  //   apiService.inputResonse({ token, refresh: false, bot: "agent-assist" }).then((response) => {
  //     let data = response?.data?.chatResponse?.entries;
      
  //     setDisableInputBox(!response?.data?.chatResponse?.enableDefaultTextBox)

  //     if (data) {
  //         setCode(data[1]?.code); 
  //     }
  // });
  
  };

  const startLogin = () => {
    const sessionValue = sessionStorage.getItem("agenIdS360");
    const userSession = sessionStorage.getItem("userIdS360");
    const user =
      sessionValue !== null && sessionValue !== "undefined"
        ? sessionValue
        : userDetails || userSession;

    if (user) {
      apiService
        .loginForLink(user ,agentGroup , agentType , agentName, agentLogID ,uniqueId)
        .then((response) => {
          const token = response?.data?.token;
          const userInfo = response?.data?.userInfo;

          chatReopenFunction(token);
          setToken(token);
          sessionStorage.setItem("token", token);
          sessionStorage.setItem("inputSessionId", JSON.stringify(response?.data?.sessionId));
          const userName = userInfo?.customerName || "Testing";
          localStorage.setItem("userName", JSON.stringify(userName));
        })
        .catch((error) => {
          console.error("Error during loginForLink API call:", error);
        });
    } else {
      console.log("sendNewOutsideLinkApi", props.userDetails);
    }
  };

  const onClickEvent = () => {
    setIsShowBot(true);
    startLogin();
  };


  useEffect(() => {
    if (hasEffectRun.current) return;
    
    const timeoutId = setTimeout(() => {
      verifyAgent && launchOnButton && onClickEvent();
      hasEffectRun.current = true;
    }, 1000);

    return () => clearTimeout(timeoutId); // Cleanup in case component unmounts

  }, [verifyAgent]);

  useEffect(() => {
    if (messagesEndRef.current) {
      scrollToBottom();
    }
  }, [messages, isFeedbackPop]);

  useEffect(() => {
    setFinalTimerFlag(true)
  }, [messages]);

  //msg.type !== "CUSTOMER" && showMaximumChat

  const checkIntroPage = () => {
    if (messages?.length === 0 && showMaximumChat) {
      return true;
    }
  };

  const handleCloseUrlPopup = () =>{
    setShowUrlPopUp({ isActive: false, url: "" })
  }

  // Re-disable old buttons in main chat when switching back to main tab
  useEffect(() => {
    if (activeTab === "main" && messagesEndRef.current && messages.length > 1) {
      const container = messagesEndRef.current;
      const conversations = container.getElementsByClassName('oneConversation');
      for (let i = 0; i < conversations.length - 1; i++) {
        handledButtonsUI(conversations[i]);
      }
      setTimeout(() => {
        const c = messagesEndRef.current;
        if (c) c.scrollTo({ top: c.scrollHeight, behavior: 'smooth' });
      }, 100);
    }
  }, [activeTab]);

  // Tab system handlers
  const resetAllTabs = () => {
    setTabs([{ id: "main", label: "Chat", closable: false }]);
    setTabSessions({});
    setActiveTab("main");
    openingTabsRef.current.clear();
  };

  const closeTab = (tabId) => {
    const closingTabIndex = tabs.findIndex((tab) => tab.id === tabId);
    const remainingTabs = tabs.filter((tab) => tab.id !== tabId);

    setTabs(remainingTabs);
    setTabSessions((prev) => {
      const copy = { ...prev };
      delete copy[tabId];
      return copy;
    });
    if (activeTab === tabId) {
      const remainingWorkflowTabs = remainingTabs.filter((tab) => tab.id !== "main");
      const nextTab =
        remainingTabs[Math.min(closingTabIndex, remainingTabs.length - 1)] ||
        remainingTabs[Math.max(0, closingTabIndex - 1)];
      const nextWorkflowTab =
        (nextTab?.id !== "main" && nextTab) || remainingWorkflowTabs[0];

      setActiveTab(nextWorkflowTab?.id || "main");
    }
  };

  const onUpdateSession = useCallback((tabId, updates) => {
    setTabSessions((prev) => ({
      ...prev,
      [tabId]: { ...prev[tabId], ...updates },
    }));
    if (updates.loading === false) {
      setTabs((prev) => prev.map((t) => t.id === tabId ? { ...t, loading: false } : t));
    }
  }, []);

  const openWorkflow = async (
    label,
    buttonOpCode,
    mappedId,
    escalationId,
    selectedBoxNumber,
    selectedConsent
  ) => {
    const tabId = `workflow-${mappedId || buttonOpCode}`;

    // If tab exists, switch to it
    if (tabs.find((t) => t.id === tabId)) {
      setActiveTab(tabId);
      return;
    }

    // Prevent duplicate clicks
    if (openingTabsRef.current.has(tabId)) return;
    openingTabsRef.current.add(tabId);

    // Create loading tab with a loading placeholder message
    const newTab = { id: tabId, label, closable: true, loading: true };
    const loadingMsg = {
      text: "...",
      type: "SERVER",
      date: new Date().toISOString(),
      messageCount: "SERVER-0",
      isLoading: true,
      time: new Date().toLocaleString('en-IN', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true }).replace(' at ', ', '),
    };
    setTabs((prev) => [...prev, newTab]);
    setTabSessions((prev) => ({
      ...prev,
      [tabId]: { sessionId: null, token: null, messages: [loadingMsg], code: null, loading: true, error: false },
    }));
    setActiveTab(tabId);

    try {
      const parentSessionId = sessionStorage.getItem("inputSessionId");
      const userDetailsForLogin = sessionStorage.getItem("userIdS360") || userDetails
      const subRes = await apiService.loginSubSession(
        userDetailsForLogin, agentGroup, agentType, agentName, agentLogID, uniqueId, parentSessionId, label
      );
      const subToken = subRes?.data?.token;
      const subSessionId = subRes?.data?.sessionId;

      // Call workflow API
      const chatRes = await apiService.inputResonse({
        bot: "agent-assist",
        code: buttonOpCode,
        token: subToken,
        input: encodeURIComponent(JSON.stringify({
          key1: selectedBoxNumber || `${label}- QA`,
          ...(selectedConsent && selectedConsent != 'NA' && { key2: selectedConsent }),
          count: Math.random(),
        })),
        label: encodeURIComponent(JSON.stringify({ key1: label, count: Math.random() })),
        ...(escalationId !== undefined && escalationId !== null && { id: escalationId }),

      });

      const entries = chatRes?.data?.chatResponse?.entries || [];
      const newCode = entries.length > 0 ? entries[entries.length - 1]?.code || null : null;
      const timestamp = new Date().toLocaleString('en-IN', {
        year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true
      }).replace(' at ', ', ');

      const serverData = {
        entries,
        type: "SERVER",
        messageCount: "SERVER-1",
        time: timestamp,
        viewMenuInfo: chatRes?.data?.chatResponse?.viewMenuInfo || null,
        end: chatRes?.data?.chatResponse?.end || false,
      };

      setTabSessions((prev) => ({
        ...prev,
        [tabId]: { sessionId: subSessionId, token: subToken, messages: [serverData], code: newCode, loading: false, error: false },
      }));
      setTabs((prev) => prev.map((t) => t.id === tabId ? { ...t, loading: false } : t));
    } catch (err) {
      console.error("openWorkflow error:", err);
      setTabSessions((prev) => ({
        ...prev,
        [tabId]: { ...prev[tabId], loading: false, error: true },
      }));
      setTabs((prev) => prev.map((t) => t.id === tabId ? { ...t, loading: false } : t));
    } finally {
      openingTabsRef.current.delete(tabId);
    }
  };

  // main UI starts here
  return (
    <div
      className={
        showMinimizedChat
          ? "minimizedPageWrapper"
          : showMaximumChat
          ? "fullPageWrapper"
          : "wrapper"
      }
    >
      {/* //feedback popUp */}
      {showMaximumChat && isFeedbackPop && (
        <FeedbackPopUp
          setIsFeedbackPop={setIsFeedbackPop}
          showMaximumChat={showMaximumChat}
          sessionId={sessionId}
          setCheckThumsDownFeedback={setCheckThumsDownFeedback}
          checkThumsDownFeedback={checkThumsDownFeedback}
          index={IndexForPopUp}
        />
      )}

      {!isShowBot && verifyAgent && (
        <div
          style={{ fontSize: "1.75rem" }}
          className="bot-icon bot-icon-iframe"
        >
          <RobotOutlined onClick={() => onClickEvent()} />
        </div>
      )}

      {isShowBot && (
        <div
          className={
            showMinimizedChat
              ? "minimizedPageContainer minimized-screen"
              : showMaximumChat
              ? "fullPageBotContainer"
              : "bot-container chatIn-header"
          }
        >
          {
            <Header
              handleClose={handleClose}
              showMinimizedChat={showMinimizedChat}
              showMaximumChat={showMaximumChat}
              setShowMinimizedChat={setShowMinimizedChat}
              setIsShowMaximumChat={setIsShowMaximumChat}
              clearMessages={clearMessages}
              setShowMsgs={setShowMsgs}
              startLogin={startLogin}
              setFinalTimerFlag={setFinalTimerFlag}
              setCheckThumsDownFeedback={setCheckThumsDownFeedback}
              setShowR1FeedbackPop={setShowR1FeedbackPop}
              hasActiveTabs={tabs.length > 1}
              resetAllTabs={resetAllTabs}
              setActiveTab={setActiveTab}
            />
          }
          {!showMinimizedChat && (
            <>
              {showMaximumChat && tabs.length > 1 && (
                <TabBar
                  tabs={tabs}
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                  closeTab={closeTab}
                  sessionId={
                    activeTab !== "main"
                      ? tabSessions[activeTab]?.sessionId
                      : tabs
                          .filter((tab) => tab.id !== "main")
                          .map((tab) => tabSessions[tab.id]?.sessionId)
                          .find(Boolean) || null
                  }
                />
              )}
              <div style={{ height: "80%", display: "flex", width: "100%", justifyContent : showUrlPopUp.isActive && 'center', flex: 1, position: 'relative' }}>

              {showUrlPopUp.isActive && (
                <ChatPopup handleCloseUrlPopup={handleCloseUrlPopup} showUrlPopUp={showUrlPopUp} />
              )}

              <div
                key="main-tab"
                ref={messagesEndRef}
                style={{ height: showMaximumChat && "100%", flex: 1, overflow: 'auto', minWidth: 0, display: activeTab === "main" ? 'block' : 'none' }}
                className={
                  (showMaximumChat ? "fullPageBotChatWrap" : "bot-chat-wrap") + " tab-content-animated"
                }
              >
                <Conversation
                  setShowMsgs={setShowMsgs}
                  showMsgs={showMsgs}
                  messages={messages}
                  updateMessage={updateMessage}
                  setIsFeedbackPop={setIsFeedbackPop}
                  isFeedbackPop={isFeedbackPop}
                  clearMessages={clearMessages}
                  loading={loading}
                  showMaximumChat={showMaximumChat}
                  scrollToBottom={scrollToBottom}
                  token={token}
                  sessionId={sessionId}
                  startLogin={startLogin}
                  setIsThirtyMinPopUP={setIsThirtyMinPopUP}
                  IsThirtyMinPopUP={IsThirtyMinPopUP}
                  setIsShowBot={setIsShowBot}
                  setDisableInputBox={setDisableInputBox}
                  checkThumsDownFeedback={checkThumsDownFeedback}
                  setCheckThumsDownFeedback={setCheckThumsDownFeedback}
                  setIndexForPopUp={setIndexForPopUp}
                  setisSubscriber={setisSubscriber}
                  isSubscriber={isSubscriber}
                  addMessages={addMessages}
                  addMessagesPhase2={addMessagesPhase2}
                  setIsShowMaximumChat={setIsShowMaximumChat}
                  saveFeedbackData={saveFeedbackData}
                  setSaveFeedbackData={setSaveFeedbackData}
                  showR1FeedbackPop={showR1FeedbackPop}
                  setShowR1FeedbackPop={setShowR1FeedbackPop}
                  setShowUrlPopUp={setShowUrlPopUp}
                  // downtime={downtime}
                  openWorkflow={openWorkflow}
                  onQuickActionsChange={onQuickActionsChange}
                  resetAllTabs={resetAllTabs}
                  {...props}
                />
              </div>
              {tabs.filter(t => t.id !== "main").map(tab => {
                const session = tabSessions[tab.id];
                if (!session) return null;
                const isActive = activeTab === tab.id;
                const hasA62 = session.messages?.some(m => m.entries?.some(e => e.uiCommand === "A62"));
                if (!isActive && !hasA62) return null;
                return (
                  <div key={tab.id} className={isActive ? "tab-content-animated" : ""} style={{ display: isActive ? 'flex' : 'none', flex: 1, minWidth: 0, height: '100%' }}>
                    <WorkflowChat
                      ref={isActive ? workflowChatRef : undefined}
                      tabId={tab.id}
                      sessionId={session.sessionId}
                      token={session.token}
                      messages={session.messages}
                      code={session.code}
                      loading={session.loading}
                      error={session.error}
                      onUpdateSession={onUpdateSession}
                      showMaximumChat={showMaximumChat}
                      setIsShowMaximumChat={setIsShowMaximumChat}
                      flow={flow}
                      isActive={isActive}
                      addMessagesFeedback={props.addMessagesFeedback}
                    />
                  </div>
                );
              })}

              {showMaximumChat && quickActionData && (
                <A1MenuButtons
                  data={quickActionData}
                  addMessages={addMessages}
                  showMaximumChat={showMaximumChat}
                  setIsShowMaximumChat={setIsShowMaximumChat}
                  loading={loading}
                  scrollToBottom={scrollToBottom}
                  viewMenuInfo={quickActionViewMenu}
                  openWorkflow={openWorkflow}
                  tabs={tabs}
                />
              )}

              </div>
            </>
          )}
          {!showMinimizedChat && (
            <div
              style={{
                display: "flex",
                justifyContent: checkIntroPage() ? "center" : "",
                height: "12%",
              }}
            >
              <Footer
                inputValue={inputValue}
                handleInput={handleInput}
                handleSend={handleSend}
                handleKeyPress={handleKeyPress}
                showMaximumChat={showMaximumChat}
                checkIntroPage={checkIntroPage}
                disableInputBox={activeTab === "main" ? disableInputBox : (workflowChatRef.current?.getDisableInputBox?.() || false)}
                loading={activeTab === "main" ? loading : (tabSessions[activeTab]?.loading || false)}
                isSubscriber={isSubscriber}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
}
